<template>
  <div v-if="payMethods.orderId" class="stage-pay-method">
    <h5>
      <el-switch v-model="morePaySwitch"></el-switch>
      开启后支持两种收款方式进行结算（赊账只能使用单种支付方式，扫码和SmartBox不能同时使用）
    </h5>
    <ul class="list">
      <li v-for="(item,index) in payTypeList" v-show="item.isOpen == 0 ? payMethods.cardNo ? item.type == 3 ? payMethods.ctName == '储值卡' ? true : false : true : item.type == 3 || item.type == 5 ? false : true : false" :key="index" :class="item.status == true ? 'active' : ''" @click="selectPayType(item,item.type,index)">
        <!-- <li v-for="(item,index) in payTypeList" v-if="item.type == 4 ? false : payMethods.cardNo ? item.type == 3 ? payMethods.ctName == '储值卡' ? true : false : true : item.type == 3 || item.type == 5 ? false : true" :key="index" :class="item.status == true ? 'active' : ''" @click="selectPayType(item,item.type)"> -->
        <p class="icon">
          <i :class="'iconfont '+item.icon"></i>
        </p>
        <el-tooltip effect="light" placement="top" :disabled="tooltipStatus">
          <div slot="content">
            <p class="text">{{ item.name }}</p>
          </div>
          <p class="text" @mouseover="tooltipStatus = Lib.textShow($event,16)">{{ item.name }}</p>
        </el-tooltip>
      </li>
    </ul>
    <div v-if="(morePaySwitch == false && payType == 1) || (morePaySwitch == true && payNum >= 0) || (morePaySwitch == false && payType == 23)" class="pay-cash">
      <span v-if="morePaySwitch == false && payTypeList[0].status == true" style="float: left;">现金：</span>
      <el-input v-if="morePaySwitch == false && payTypeList[0].status == true" v-model.trim="payamount" class="input" oninput="this.value = this.value.replace(/[^\d\.]|(?<=\d?\.\d?)\.|(?<=\d+\.\d{2})[\d+\.]/g, '')" :min="0" type="number" placeholder="请输入现金金额" @keyup.enter.native="Lib.keyboardBlur" @input="changePayamount"></el-input>
      <div v-for="(a,b) in payTypeList" :key="b">
        <span v-if="(morePaySwitch == true && a.status == true) || (morePaySwitch == false && a.status == true && a.type == 23)" style="float: left;">{{ a.name }}：</span>
        <el-input v-show="(morePaySwitch == true && a.status == true) || (morePaySwitch == false && a.status == true && a.type == 23)" v-model.trim="a.price" class="input" :min="0" type="number" :placeholder="'请输入'+a.name+'金额'" :disabled="a.type == 23 && morePaySwitch == false ? true : false" @keyup.enter.native="Lib.keyboardBlur" @input="totalPayTypeMoney(a)"></el-input>
      </div>
      <div v-if="morePaySwitch == false && payTypeList[0].status == true">
        找零：
        <span class="number" v-text="'¥'+returnPayMoney"></span>
      </div>
      <div v-if="morePaySwitch == true && payTypeList[2].status == true">
        会员余额：
        <span class="number">¥{{ payMethods.memberMoney }}</span>
      </div>
      <div v-if="payTypeList[9].status == true">
        货款余额：
        <span class="number">¥{{ customerMsg.memberMsg.loanBalance || 0 }}</span>
        <samp style="font-size: 12px;color: #666;">（货款余额支付最多只能支付￥{{ wholesalePrice }}）</samp>
      </div>
    </div>

    <div v-for="(item,index) in payTypeList" v-show="chooseMoheCode != null && (item.type == 6 || item.type == 21) && item.status" :key="index" class="mohe">
      <div class="mohe-body">
        <div style="margin-bottom: 10px;">
          <span style="color: #333;font-size: 14px;">默认推送设备</span>
        </div>
        <div>
          <span style="font-size: 12px;color: #999">选择设备后，点击【确定/确定支付】订单将推送到SmartBox支付；默认使用微信支付，如需更改支付方式，请在SmartBox中进行切换</span>
        </div>
        <div class="mohe-number">
          <ul>
            <li v-for="(mh,v) in magicBox" v-show="mh.code == chooseMoheCode" :key="v" class="active">
              <el-tooltip class="item" effect="light" :content="mh.eq_name" placement="left-start">
                <div class="mohe-dialog-text">{{ mh.eq_name }}</div>
              </el-tooltip>
            </li>
          </ul>
          <div style="font-size: 12px;margin:-0px 0 5px 0,color: #999;">
            如果修改SmartBox请
            <span class="themeFC" style="cursor:pointer" @click="moheDialog =true">点击这里</span>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="title" :visible.sync="dialogVisiblePayType4" width="590px" :append-to-body="true" :close-on-press-escape="false" :close-on-click-modal="false" @close="handleClosePayType4">
      <div v-if="payType==5" class="gz-box">
        <div class="gz-left">
          <p>方式1：现场扫码授权</p>
          <img :src="payType4ErweiMa" style="width: 100%;">
          <p>请打开app扫码授权</p>
        </div>
        <div class="gz-right">
          <p class="padding30">方式2：非现场授权</p>
          <el-select v-model="creditListValue" class="padding30" placeholder="请选择">
            <el-option v-for="item in creditList" :key="item.membername" :label="item.membername+' '+'（'+item.phone+'）'" :value="item.phone">
            </el-option>
          </el-select>
          <p style="padding-bottom:20px;">提示：授权通过，十分钟内有效</p>
          <p style="padding-bottom:40px;height: 38px;">
            <label v-show="tenTimeReturnFlag">
              您已发送授权短信，<br />短信剩余有效时长为
              <span v-text="tenTimeReturnNum"></span>分钟
            </label>
          </p>
          <div style="text-align: right;">
            <el-button type="primary" :disabled="tenTimeReturnFlag" @click="sendMsg4Serve">确定发送</el-button>
          </div>
        </div>
      </div>
      <div v-if="payType==4">
        <div class="commonNewPay" style="width: 500px;">
          <img style="margin: auto;display: block;margin-bottom: 20px;" src="static/images/default/scanCode.gif" />
          <p>
            需支付金额：
            <span v-text="'¥'+resulteMoneyGz"></span>
          </p>
          <img class="hdScanIcon" src="static/images/icon/Scan.png" @click="getHdCamera" />
          <el-input ref="refsqp" v-model="paymentCode" v-focus :disabled="scanQPayLoading" placeholder="使用扫码枪扫码或输入付款码" class="input-with-select scanInput" style="width: 300px !important;margin: 10px 90px 10px 92px;" @keyup.enter.native="scanQPaySubmit">
            <el-button slot="append" type="primary" style="color: #fff;height: 40px;" :loading="scanQPayLoading" @click="scanQPaySubmit">确定</el-button>
          </el-input>
          <p class="themeFC">支付过程中请勿关闭窗口，因网络问题引起的延迟，请耐心等候</p>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="smartBoxStatus == 21 ? 'SmartBox收款码' : 'SmartBox'" :visible.sync="moheDialog" custom-class="mohe-dialog2" :append-to-body="true" width="916px">
      <div class="mohe-dialog">
        <div style="margin-bottom: 8px;">
          <label>订单金额：</label>
          <span style="color: lightcoral">¥ {{ mohePayMoney }}</span>
        </div>
        <div style="margin-bottom: 8px;">请选择SmartBox设备</div>
        <div v-if="smartBoxStatus == 6" style="color: #8c939d">选择设备后，点击【确定/确定买单】订单将推送到SmartBox支付</div>
        <div v-if="smartBoxStatus == 6" style="color: #8c939d;margin-bottom: 15px;">如需更改支付方式，请在SmartBox中进行切换</div>
        <div v-if="smartBoxStatus == 21" style="color: #8c939d;margin-bottom: 15px;">选择设备后，点击【确定/确定买单】订单的收款码将推送到SmartBox，让顾客扫码支付</div>
        <div class="mohe-dialog-number">
          <ul v-if="magicBox.length > 0 ? true : false" class="clearFix">
            <li v-for="(mh,index) in magicBox" :key="index" :class="{'active': mh.code == defultMoheCode}" @click="changeMohe(mh)">
              <el-tooltip class="item" effect="light" :content="mh.eq_name" placement="left-start">
                <div class="mohe-dialog-text">{{ mh.eq_name }}</div>
              </el-tooltip>
            </li>
          </ul>
          <gt-noneData v-if="loading == false && magicBox.length == 0 " :title="'暂无数据'"></gt-noneData>
        </div>
      </div>
      <div slot="footer" class="dialog-footer fr">
        <el-button type="primary" size="small" @click="moheChooseConfirm">确 定</el-button>
        <el-button size="small" @click="moheDialog = false">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="mohePayStatus" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :append-to-body="true">
      <span>订单已推送，请顾客在SmartBox进行扫码支付<br>正在支付中，请勿关闭该窗口！</span>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="smartBoxStatus == 21" type="text" @click="closeMohePay">取消推送</el-button>
        <el-button v-else @click="closeMohePay">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 扫码支付 -->
    <el-dialog title="扫码支付" :visible.sync="scanDialog" custom-class="scan-dialog" width="590px" :close-on-click-modal="false" :append-to-body="true" @close="closeScanDialogDialog">
      <div class="commonNewPay" style="width: 500px;">
        <img style="margin: auto;display: block;margin-bottom: 20px;" src="static/images/default/scanCode.gif" />
        <p>
          需支付金额：
          <span v-text="'¥'+scanTotal"></span>
        </p>
        <img class="hdScanIcon" src="static/images/icon/Scan.png" @click="getHdCamera" />
        <el-input ref="refsqp" v-model="paymentCode" v-focus :disabled="scanQPayLoading" placeholder="使用扫码枪扫码或输入付款码" class="input-with-select scanInput" style="width: 300px !important;margin: 10px 90px 10px 92px;" @keyup.enter.native="scanQPaySubmit">
          <el-button slot="append" type="primary" style="color: #fff;" :loading="scanQPayLoading" @click="scanQPaySubmit">确定</el-button>
        </el-input>
        <p class="themeFC">支付过程中请勿关闭窗口，因网络问题引起的延迟，请耐心等候</p>
      </div>
      <!-- <div v-if="scanDialog">
                <div style="margin-top: -15px;">需支付金额：
                    <strong style="color: #f08080">¥ {{scanTotal}}</strong>
                </div>
                <div class="clearFix">
                    <div class="scan-left">
                        <div class="pay1">
                            <strong>方式一：</strong>顾客扫码支付</div>
                        <div class="select-button" style="margin-top: 15px;position: relative;z-index: 99;">
                            <el-radio class="radio" v-model="changePayRadioVal" :disabled="changePayRadio" :label="1">微信</el-radio>
                            <el-radio class="radio" v-model="changePayRadioVal" :disabled="changePayRadio" :label="2">支付宝</el-radio>
                        </div>
                        <div class="pay-scan">
                            <img v-if="!scanPayRadio2" :alt="scanCodeUrl" :src="scanCodeUrl" ref="img" />
                            <div class="pay-scan-msg" v-if="scanPayRadio2">请在方式二支付!</div>
                        </div>
                        <div class="pay-1" v-if="morePaySwitch && !scanPayRadio2">
                            <span>使用第二次支付</span>
                            <el-switch v-model="scanPayRadio1" on-text="开启" :disabled="scanPayMoney1Result" off-text="关闭" style="margin-left: 15px"></el-switch>
                        </div>
                        <div class="pay-1-input" v-if="morePaySwitch && scanPayRadio1">
                            <el-input @keyup.enter.native="Lib.keyboardBlur" class="scanInput" placeholder="第一次支付金额" v-model="scanPayMoney1" :readonly="scanPayMoney1Result" @input.native="changeScanPayMoney"></el-input>
                            <span class="scanSpan" v-if="scanPayMoney1Result">已付款</span>
                            <el-input @keyup.enter.native="Lib.keyboardBlur" class="scanInput" placeholder="第二次支付金额" v-model="scanPayMoney2" readonly></el-input>
                            <span class="scanSpan" v-if="scanPayMoney2Result">已付款</span>
                            <p style="font-size: 12px;color: #999;height: 20px;line-height: 20px;padding-top: 15px;">第一次支付金额填写后，支付码自动刷新</p>
                        </div>
                    </div>
                    <div class="scan-right">
                        <div class="pay2">
                            <strong>方式二：</strong>营业员输入</div>
                        <div class="select-button" style="margin-top: 15px;">
                            <el-radio class="radio" v-model="scanSelect" :disabled="scanPayRadio1" :label="0">微信</el-radio>
                            <el-radio class="radio" v-model="scanSelect" :disabled="scanPayRadio1" :label="1">支付宝</el-radio>
                        </div>
                        <div class="right-input">
                            <el-input @keyup.enter.native="Lib.keyboardBlur" style="width: 240px;" v-model="scanPayCode" :disabled="scanPayRadio1" placeholder="请使用扫码枪扫描或键盘输入付款码"></el-input>
                        </div>
                        <div class="input-money clearFix">
                            <el-button style="float: right;margin-right: 54px;" type="primary" :disabled="scanPayRadio1" @click="scanCustomersPay()">确定</el-button>
                        </div>
                        <div class="pay-2" v-if="morePaySwitch && !scanPayRadio1">
                            <span>使用第二次支付</span>
                            <el-switch v-model="scanPayRadio2" :disabled="scanPayMoney1Result" on-text="开启" off-text="关闭" style="margin-left: 15px"></el-switch>
                        </div>
                        <div class="pay-2-input" v-if="morePaySwitch && scanPayRadio2">
                            <el-input @keyup.enter.native="Lib.keyboardBlur" class="scanInput" placeholder="第一次支付金额" v-model="scanPayMoney1" :readonly="scanPayMoney1Result" @input.native="changeScanPayMoney"></el-input>
                            <span class="scanSpan" v-if="scanPayMoney1Result">已付款</span>
                            <el-input @keyup.enter.native="Lib.keyboardBlur" class="scanInput" placeholder="第二次支付金额" v-model="scanPayMoney2" readonly></el-input>
                            <span class="scanSpan" v-if="scanPayMoney2Result">已付款</span>
                            <p style="font-size: 12px;color: #999;height: 20px;line-height: 20px;padding-top: 15px;">第一次支付金额填写后，支付码自动刷新</p>
                        </div>
                    </div>
                </div>
            </div> -->
    </el-dialog>

    <el-dialog title="会员消费密码" :visible.sync="payPasswordDia" width="520px" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <gt-consumptionCode :member-card="customerMsg.memberMsg" @successPassword="successPassword"></gt-consumptionCode>
    </el-dialog>

    <el-dialog :title="(getRoomType == 1 ? '选择退房' : '选择退位') + Lib.returnRoomOrBed()" :visible.sync="roomDia" width="1000px" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
      <el-table ref="outRoomTable" tooltip-effect="light" :data="dtoList" style="width: 100%;" @selection-change="chooseOutBed">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column prop="name" :label="Lib.returnRoomOrBed() + '名称'" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="customerName" width="120" label="顾客姓名">
          <template slot-scope="scope">
            <span>{{ scope.row.customerName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="customerPhone" width="120" label="手机号码">
          <template slot-scope="scope">
            <span>{{ scope.row.customerPhone || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="beginTime" label="使用时间" show-overflow-tooltip />
        <el-table-column prop="endTime" label="预离时间" show-overflow-tooltip />
        <el-table-column prop="dateTime" label="使用时长" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ Lib.calculationTime(scope.row.dateTime) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="chooseOutBedList.length > 0 ? false : true" @click="chooseOutBedList.length > 0 ? toPay('room') : ''">确 定</el-button>
      </span>
    </el-dialog>

    <Autograph ref="child" :btn-disable="btnDisable" @getCanvas="getCanvasUrl"></Autograph>
  </div>
</template>
<script>
import Vue from 'vue';
import {
  getQRCode4ScanPay, getScanPayStatus, getQRCode4Credit, toPay, toPayBefore, sendMsg4Serve, getMagicBoxList,
  barCodePay, receptionOrder, getOrderCode, newGetScanPayStatus, newBarCodePay, getPaySet, getPayCodeList, payQrOrderPush, cancelSmartBoxPush
} from '../api';

let scanPayTimeout;
export default {
  props: {
    payMethods: {
      type: Object,
      default() {
        return {
          orderId: '',
          money: '',
          discountMoney: '',
          cardNo: ''
        };
      }
    },
    customerMsg: {
      type: Object,
      default() {
        return { cardNo: '' };
      }
    },
    settlementMsg: {
      type: String,
      default: ''
    },
    onAccountAuth: {
      type: Number,
      default: 0
    },
    isPartPay: {
      type: Number,
      default: 0
    },
    editMoneyVal: {
      type: Number,
      default: 0
    },
    wholesalePrice: {
      type: Number,
      default: 0
    },
    dtoList: {
      type: Array,
      default: Array
    },
    btnDisable: {
      type: Function,
      default: Function
    }
  },
  data() {
    return {
      payamount: '',
      payType: 0,
      comitData: {
        bankCode: '', // 银行流水号
        payType: '',
        payamount: '', // 现金支付客户支付的金额
        returnamount: '' // 现金支付找回客户的金额
      },
      returnPayMoney: '0',
      binkOrderNumber: '',
      dialogVisiblePayType4: false,
      payType4ErweiMa: '',
      clearGetScanPayStatus: null,
      clearScanQPayStatus: null,
      title: '',
      creditList: [],
      creditListValue: '',
      tenTimeReturnClear: null,
      tenTimeReturnNum: 10,
      tenTimeReturnFlag: false,
      resulteMoney: 0,
      resulteMoneyGz: 0,
      changePayImgStatus: true, // 扫码支付切换支付方式，true为微信支付，fasle为支付宝支付
      morePaySwitch: false, // 多种支付开关
      payTypeList: [
        {
          name: '现金',
          type: 1,
          status: false,
          icon: 'icon-zhifu-01',
          price: null
        }, {
          name: '银行卡',
          type: 2,
          status: false,
          icon: 'icon-yinhangqia',
          price: null
        }, {
          name: '会员卡',
          type: 3,
          status: false,
          icon: 'icon-vip',
          price: null
        }, {
          name: '扫码支付',
          type: 4,
          status: false,
          icon: 'icon-saoma1',
          price: null
        }, {
          name: '赊账',
          type: 5,
          status: false,
          icon: 'icon-guazhang',
          price: null
        }, {
          name: 'SmartBox',
          type: 6,
          status: false,
          icon: 'icon-hezixiangzi',
          price: null
        }, {
          name: '个人微信',
          type: 7,
          status: false,
          icon: 'icon-weixin2',
          price: null
        }, {
          name: '个人支付宝',
          type: 8,
          status: false,
          icon: 'icon-zhifubao',
          price: null
        }, {
          name: 'SmartBox收款码',
          type: 21,
          status: false,
          icon: 'icon-SmartBoxshoukuanma',
          price: null
        }, {
          name: '货款余额',
          type: 23,
          status: false,
          icon: 'icon-zhifu-01',
          price: null
        }
      ],
      choosePayVal: 0,
      moheDialog: false, // SmartBox支付弹框
      magicBox: [], // SmartBox设备列表数据
      defultMoheCode: null, // 默认SmartBox
      chooseMoheCode: null, // 选择的SmartBox设备
      mohePayMoney: '0.00', // SmartBox支付的金额

      scanDialog: false, // 多种支付--扫码支付
      changePayRadioVal: 1, // 多种支付--扫码支付方式一  1为微信扫码，2为支付宝扫码
      changePayRadio: false, // 多种支付--扫码支付方式一是否禁用
      scanPayRadio1: false, // 顾客主扫
      scanPayRadio2: false, // 营业员主扫
      scanPayMoney1: null, // 扫码第一次支付
      scanPayMoney2: null, // 扫码第二次支付
      scanPayMoney1Result: false, // 扫码第一次支付结果
      scanPayMoney2Result: false, // 扫码第二次支付结果
      scanCodeUrl: '', // 扫码支付二维码
      scanTotal: '', // 扫码支付金额
      scanSelect: 0, // 营业员输入0微信，1支付宝
      scanPayCode: '', // 支付码
      mohePayStatus: false, // SmartBox支付弹出窗口状态
      isCloseScan: false, // 关闭扫码窗口
      morePayOrderCode: '', // 多种支付生成的订单号

      sanQPayOrder: '', // 扫码支付订单号
      paymentCode: '', // 扫码支付--付款码
      scanQPayLoading: false, // 扫码支付--确定按钮loading

      paySetStatus: '',
      payCodeList: [], // 支付方式列表数据
      tooltipStatus: false, // 气泡显示
      payNum: -1, // 多种支付--选择的支付方式数量
      payStatus: 1,

      // 5.7
      payPasswordDia: false,
      payPassword: '',

      // 6.2
      mhInfo: {},
      smartBoxStatus: 6,

      // 6.3
      loading: true,

      // 6.7
      orderSignature: '',

      // 6.8
      roomDia: false,
      getRoomType: window.sessionStorage.tidyStatus, // 设置的房态  1房间  2床位  3台位(5.10)
      chooseOutBedList: [], // 选择退房/退位的列表
    };
  },
  watch: {
    // 输入现金
    payamount() {
      this.getReturnMoney();
    },
    // 支付方式
    payType() {
      if (this.payType == 1) {
        const settlementMsg = window.JSON.parse(this.settlementMsg);
        this.payamount = this.toFixeds(settlementMsg.resulteMoney);
      } else {
        this.payamount = '';
      }
      this.binkOrderNumber = '';
      this.$emit('getPayMethodsMsg', this.putOutPayMethodsMsg());
    },
    // 结算信息   监听父组件数据
    settlementMsg() {
      this.resulteMoney = window.JSON.parse(this.settlementMsg).resulteMoney;
      // this.payType = 1
      this.getReturnMoney();
      const settlementMsg = window.JSON.parse(this.settlementMsg);
      if (this.payType == 23 && (settlementMsg.resulteMoney * 1 != settlementMsg.totalMoney * 1)) {
        this.payTypeList.forEach((val) => {
          val.status = false;
        });
        this.payType = 0;
      }
      this.payamount = this.toFixeds(settlementMsg.resulteMoney);
      this.resulteMoney = this.toFixeds(settlementMsg.resulteMoney);
      this.resulteMoneyGz = window.JSON.parse(this.settlementMsg).resulteMoney;
    },
    // 监听选择多种支付方式
    morePaySwitch(val) {
      this.$emit('getPayMethodsMsg', this.putOutPayMethodsMsg());
      if (val) {
        this.payTypeList.forEach((a) => {
          a.status = false;
        });
        this.totalPayCode();
        this.payTypeList[0].status = false;
      } else {
        this.payTypeList.forEach((a) => {
          a.status = false;
        });
        this.payTypeList[0].status = true;
        this.totalPayCode();
        this.payType = 0;
      }
    },
    // 监听SmartBox弹框显示与否
    moheDialog(val) {
      if (val == true) {
        this.defultMoheCode = this.chooseMoheCode;
        if (!this.morePaySwitch) {
          const settlementMsg = window.JSON.parse(this.settlementMsg);
          this.mohePayMoney = settlementMsg.resulteMoney;
        }
      }
    },
    // 多种支付--方式一的按钮状态
    scanPayRadio1() {
      if (!this.isCloseScan) {
        this.toPay('66');
        this.isCloseScan = false;
      }
    },
    changePayImgStatus(val) {
      const settlementMsg = window.JSON.parse(this.settlementMsg);
      const data = {
        orderId: window.sessionStorage.settlementOrderId,
        money: settlementMsg.resulteMoney,
        payWay: val ? 1 : 2
      };
      getQRCode4ScanPay(data).then((res) => {
        if (res.code == 0) {
          this.morePayOrderCode = res.data.orderCode;
          this.payType4ErweiMa = `${res.data.url}&${new Date().getTime()}`;
        }
      });
    },
    changePayRadioVal() {
      this.toPay('66');
    }
  },
  activated() {
    this.payStatus = 1;
    this.getPayList();
    window.didGetQRCode = this.returnHdCameraVal;
    const t = setTimeout(() => {
      if (this.settlementMsg) {
        const settlementMsg = window.JSON.parse(this.settlementMsg);
        this.resulteMoneyGz = settlementMsg.resulteMoney;
        this.payamount = this.toFixeds(settlementMsg.resulteMoney);
      }
      clearTimeout(t);
    }, 300);
    getPaySet({}).then((res) => {
      if (res.code == 0) {
        this.paySetStatus = res.data ? res.data : 0;
      }
    });
  },
  deactivated() {
    Object.assign(this.$data, this.$options.data());
    this.payStatus = 2;
  },
  methods: {
    chooseOutBed(val) {
      const arr = [];
      val.forEach((a) => {
        const obj = {};
        obj.roomOrderId = a.roomOrderId;
        obj.mainId = window.sessionStorage.mainId;
        arr.push(obj);
      });
      this.chooseOutBedList = arr;
    },
    getCanvasUrl(val) {
      const vm = this;
      vm.orderSignature = val;
      const loading = this.$loading({
        lock: true,
        text: '支付中，请稍等',
        spinner: 'el-icon-loading',
        customClass: 'loadNoneedImg',
        background: 'rgba(0, 0, 0, 0.5) !important'
      });
      const data = vm.toPayData();
      toPay(data).then((res) => {
        if (res.code == 0) {
          vm.$message({
            message: '订单结算成功！',
            type: 'success',
            duration: 2000,
            onClose: () => {
              vm.returnHome();
            }
          });
        } else {
          vm.$message.error(res.msg);
          vm.$emit('getPayMethodsMsg', vm.putOutPayMethodsMsg());
          vm.dialogVisiblePayType4 = false;
        }
        loading.close();
      });
    },
    getSmartBoxStatus() {
      this.payTypeList.forEach((item) => {
        if (item.type == 6 && item.status == true) this.smartBoxStatus = 6;
        if (item.type == 21 && item.status == true) this.smartBoxStatus = 21;
      });
    },
    // 输入消费密码--确定事件
    successPassword(val) {
      if (val) {
        this.payPasswordDia = false;
        this.payPassword = val;
        this.payTypeList.forEach((item, index) => {
          if (item.type == 3) {
            this.selectPayType(item, item.type, index);
          }
        });
      } else {
        this.payPasswordDia = false;
      }
    },
    // 获取支付方式列表
    getPayList() {
      const data = {
        mainId: window.sessionStorage.mainId
      };
      getPayCodeList(data).then((res) => {
        if (res.code == 0 && res.data) {
          this.payCodeList = res.data;
          res.data.forEach((a) => {
            if (a.payTypeName == '部分支付') {
              window.sessionStorage.isPartPay = a.isOpen == 0 ? 1 : 2;
            }
            if (a.payType == 32) {
              window.sessionStorage.isOrderEditPrice = a.isOpen == 0 ? 1 : 2;
            }
            if (a.payType == 40) {
              window.sessionStorage.isAutograph = a.isOpen == 0 ? 1 : 2;
            }
            if (a.payType * 1 > 99 && a.isOpen == 0) {
              const obj = {};
              obj.icon = 'icon-zhifufangshi';
              obj.isOpen = 0;
              obj.name = a.payTypeName;
              obj.price = null;
              obj.status = false;
              obj.type = a.payType;
              this.payTypeList.push(obj);
            }
          });
          this.totalPayCode();
        } else {
          this.payTypeList = [];
        }
      });
    },
    // 渲染支付方式列表数据
    totalPayCode() {
      this.payTypeList.forEach((a) => {
        this.payCodeList.forEach((b) => {
          if (a.type == b.payType) {
            a.isOpen = b.isOpen;
          }
        });
      });
    },
    // 调用HD摄像头功能
    getHdCamera() {
      const status = this.Lib.pcOrMobile();
      if (status === 'mobile') {
        if (window.webkit) {
          window.webkit.messageHandlers.scanQRCode.postMessage(1);
        } else if (typeof (dfAndroidAppHD) != 'undefined') {
          // eslint-disable-next-line no-undef
          dfAndroidAppHD.openScanQRCode('1');
        } else {
          this.$message('此功能只能在HD上使用');
        }
      }
    },
    // 摄像头回调方法
    returnHdCameraVal(code) {
      this.paymentCode = code;
    },
    // 改变现金支付金额
    changePayamount() {
      const vm = this;
      const settlementMsg = window.JSON.parse(this.settlementMsg);
      if (parseFloat(vm.payamount) < 0 || !Number(parseFloat(vm.payamount)) && vm.payamount != '' && vm.payamount != '0.0') {
        setTimeout(() => {
          vm.payamount = 0;
        }, 10);
      } else if (vm.payamount > 1000000) {
        setTimeout(() => {
          vm.$message('输入金额过大');
          vm.payamount = (settlementMsg.resulteMoney * 1).toFixed(2);
        }, 10);
      }
    },
    // 保留两位小数
    toFixeds(num) {
      return (num * 1).toFixed(2);
    },
    // 向父组件传递数据
    putOutPayMethodsMsg() {
      return {
        payType: this.payType,
        disable: false
      };
    },
    // 计算找零
    getReturnMoney() {
      const settlementMsg = window.JSON.parse(this.settlementMsg);
      this.returnPayMoney = (this.payamount - settlementMsg.resulteMoney).toFixed(2);
    },
    // 选择支付方式 -- 赊账只允许单种支付
    selectPayType(item, type, index) {
      const vm = this;
      if (vm.payPassword == '' && type == 3 && vm.customerMsg.memberMsg.inputPwd == 1) {
        vm.payPasswordDia = true;
        return;
      }
      if (vm.morePaySwitch == false && type == 23 && (vm.wholesalePrice * 1 > vm.customerMsg.memberMsg.loanBalance * 1)) {
        vm.$message(`用户货款余额不足￥${vm.wholesalePrice}，请选择多种支付或者其他支付方式`);
        return;
      }
      if (type == 23 && !vm.wholesalePrice) {
        vm.$message('非货款商品，不能使用货款余额支付');
        return;
      }
      const payMsg = window.JSON.parse(this.settlementMsg);
      if (type == 23 && (payMsg.resulteMoney * 1 != payMsg.totalMoney * 1)) {
        vm.$message({
          message: '部分支付，不能使用货款余额支付',
          type: 'error'
        });
        return;
      }
      vm.$emit('getPayMethodsMsg', vm.putOutPayMethodsMsg());
      if (vm.morePaySwitch == true) {
        if (type == 5) {
          vm.payTypeList.forEach((val) => {
            if (val.type == 1) {
              val.status = true;
            } else {
              val.status = false;
            }
            val.price = null;
          });
          vm.morePaySwitch = false;
          return false;
        }
        if (type == 4 && vm.paySetStatus == 0) {
          vm.$message('您尚未开通扫码支付');
          return;
        }
        if (type == 3 && vm.payMethods.memberMoney * 1 == 0) {
          vm.$message('会员余额不足，请换另一种支付方式！');
          return;
        }
        if (type == 23 && vm.customerMsg.memberMsg.loanBalance * 1 == 0) {
          vm.$message('货款余额不足，请换另一种支付方式！');
          return;
        }

        // 计算一共几种支付
        let selectedCount = 0;// 共选了几种支付方式
        let notMoneyCount = 0;// 没有填写金额的支付方式
        let isReturn = true;
        const settlementMsg = window.JSON.parse(this.settlementMsg);
        const payMoney = this.toFixeds(settlementMsg.resulteMoney);
        let surplusTotal = parseFloat(payMoney).toFixed(2);// 剩余分配支付金额
        vm.payTypeList.forEach((val) => {
          if (val.status && val != item) {
            if ((val.type == 4 && (item.type == 6 || item.type == 21)) || ((val.type == 6 || val.type == 21) && item.type == 4)) {
              vm.$message('不能同时选择扫码支付和SmartBox支付，请重新选择');
              isReturn = false;
              return;
            }
            if ((val.type == 6 && item.type == 21) || (val.type == 21 && item.type == 6)) {
              vm.$message('不能同时选择SmartBox支付和SmartBox收款码支付，请重新选择');
              isReturn = false;
              return;
            }
            selectedCount++;
            surplusTotal = parseFloat(surplusTotal).toFixed(2) - parseFloat((val.price || 0)).toFixed(2);
            if (val.price == null) {
              notMoneyCount++;
              vm.$message({ message: `请先输入${val.name}支付的金额!`, type: 'warning', duration: 3000 });
            }
          }
        });
        setTimeout(() => {
          vm.payNum = selectedCount;
        }, 10);
        if (!isReturn) return;
        if (notMoneyCount > 0) {
          return false;
        }
        if (selectedCount >= 2) {
          vm.$message({ message: '最多选择两种支付方式!', type: 'warning', duration: 3000 });
          return false;
        }
        if (!vm.chooseMoheCode && (type == 6 || type == 21)) {
          vm.moheDialog = true;
          if (!item.status) {
            vm.getMagicBoxList();
          }
        }
        item.status = !item.status;
        Vue.set(vm.payTypeList, index, vm.payTypeList[index]);
        item.price = parseFloat(surplusTotal).toFixed(2);
        this.totalPayTypeMoney(item);
        if (type == 6 || type == 21) {
          vm.mohePayMoney = parseFloat(surplusTotal).toFixed(2);
        }
      } else {
        if (type == 3 && vm.resulteMoneyGz * 1 > vm.payMethods.memberMoney * 1) {
          vm.$message({
            message: '会员余额不足，请换另一种支付方式！',
            type: 'error'
          });
          return;
        }
        if (type == 23 && vm.resulteMoneyGz * 1 > vm.wholesalePrice * 1) {
          vm.$message({
            message: '剩余款项未支付，请选择组合支付',
            type: 'warning'
          });
          return;
        }
        if (!vm.chooseMoheCode && (type == 6 || type == 21)) {
        // if (!vm.chooseMoheCode && type == 6) {
        //   if (Number(vm.resulteMoneyGz) == 0) {
        //     vm.$message.error('收银盒子支付的金额要大于0');
        //     return;
        //   }
          vm.moheDialog = true;
          if (!item.status) {
            vm.getMagicBoxList();
          }
        }
        vm.payTypeList.forEach((val) => {
          val.status = false;
        });
        vm.payType = type;
        if (type == 4) {
          if (vm.paySetStatus == 0) {
            vm.$message.error('您尚未开通扫码支付方式');
            return;
          }
          if (Number(vm.resulteMoneyGz) !== 0) {
            vm.paymentCode = '';
            vm.changePayImgStatus = true;
            getOrderCode({ orderCode: vm.payMethods.orderCode }).then((res) => {
              vm.sanQPayOrder = res.data.orderCode;
              vm.dialogVisiblePayType4 = true;
              vm.scanQPayLoading = false;
              vm.title = '扫码支付';
              vm.payStatus = 1;
            });
          } else {
            vm.$message.error('扫码支付的金额要大于0');
            return;
          }
        } else if (type == 5) {
          const settlementMsg = window.JSON.parse(this.settlementMsg);
          const totalOne = settlementMsg.others ? settlementMsg.others.couponMsg ? (settlementMsg.others.couponMsg.money * 1) : 0 : 0;
          const totalTwo = settlementMsg.others ? settlementMsg.others.fenBiMsg ? (settlementMsg.others.fenBiMsg.money * 1) : 0 : 0;
          const totalThree = settlementMsg.others ? settlementMsg.others.jifenMsg ? (settlementMsg.others.jifenMsg.money * 1) : 0 : 0;
          const totalMsg = (totalOne + totalTwo + totalThree + vm.editMoneyVal * 1 + (settlementMsg.others ? (settlementMsg.others.resulteMoney ? (settlementMsg.others.resulteMoney * 1) : (settlementMsg.resulteMoney * 1)) : (settlementMsg.resulteMoney * 1))).toFixed(2);
          if ((totalMsg == settlementMsg.totalMoney) && vm.isPartPay != 1) {
            if (vm.onAccountAuth == 1) {
              console.log();
            } else {
              vm.getQRCode4Credit();
            }
          } else {
            vm.$message({
              message: '已使用部分支付，不能进行赊账',
              type: 'error'
            });
            Object.assign(this.$data.payTypeList, this.$options.data().payTypeList);
            this.totalPayCode();
            this.payType = 0;
            return;
          }
        } else if (type == 3) {
          if (vm.resulteMoneyGz * 1 > vm.payMethods.memberMoney * 1) {
            vm.$message({
              message: '会员余额不足，请换另一种支付方式！',
              type: 'error'
            });
            Object.assign(this.$data.payTypeList, this.$options.data().payTypeList);
            this.totalPayCode();
            this.payType = 0;
            return;
          }
        } else if (type == 23) {
          vm.payTypeList[index].price = vm.wholesalePrice;
        }
        item.status = !item.status;
      }
      vm.getSmartBoxStatus();
    },
    sanQPayStatus() {
      const vm = this;
      vm.clearScanQPayStatus = setInterval(() => {
        const orderCode = { orderCode: vm.sanQPayOrder };
        newGetScanPayStatus(orderCode).then((res) => {
          if (vm.payStatus == 2) return;
          if (res.code == 0) {
            // 0:未支付，1：已支付，-1：已失效
            if (res.data.status == 1) {
              vm.$message({
                message: '已支付',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  vm.saveAndIsPrint();
                }
              });
              clearInterval(vm.clearScanQPayStatus);
              vm.payStatus = 2;
            } else if (res.data.status == -1) {
              vm.$message.error('二维码已失效，请重新获取');
              clearInterval(vm.clearScanQPayStatus);
              vm.payStatus = 2;
            }
          } else {
            vm.$message.error(res.msg);
            clearInterval(vm.clearScanQPayStatus);
            vm.payStatus = 2;
          }
        });
      }, 1000);
    },
    scanQPaySubmit() {
      const vm = this;
      vm.Lib.keyboardBlur();
      vm.scanQPayLoading = true;
      toPayBefore(vm.toPayData()).then(() => {
        const data = {
          sceneType: 0, // 0：erp,1:店员端,2:pad,3:小程序粉丝端
          memberType: vm.payMethods.cardNo ? 1 : 0, // 0:不使用优惠，1：会员优惠，2：星球优惠)
          orderType: 0, // 0:服务开单，1：快捷收银，2：套餐购买,3: 还款
          orderCode: vm.morePaySwitch ? vm.morePayOrderCode : vm.sanQPayOrder,
          barCode: vm.paymentCode,
          payType: vm.changePayImgStatus ? 0 : 1,
          money: vm.morePaySwitch == true ? vm.scanTotal : vm.resulteMoneyGz
        };
        newBarCodePay(data).then((res) => {
          if (res.code == 0) {
            if (vm.morePaySwitch) {
              vm.getMoreScanPayStatus();
            } else {
              vm.sanQPayStatus();
            }
          } else {
            vm.paymentCode = '';
            getOrderCode({ orderCode: vm.payMethods.orderCode }).then((resTwo) => {
              if (vm.morePaySwitch) {
                vm.morePayOrderCode = resTwo.data.orderCode;
              } else {
                vm.sanQPayOrder = resTwo.data.orderCode;
              }
              // vm.sanQPayOrder = resTwo.data.orderCode
              vm.scanQPayLoading = false;
              vm.$nextTick(() => {
                vm.$refs.refsqp.focus();
              }, 100);
            });
          }
        });
      });
    },
    // 自动计算多种支付的金额
    totalPayTypeMoney(item) {
      const vm = this;
      const settlementMsg = window.JSON.parse(this.settlementMsg);
      const payMoney = this.toFixeds(settlementMsg.resulteMoney);
      let surplusTotal;
      if (item.price.indexOf('.') > -1) {
        const arrPrice = item.price.split('.');
        if (arrPrice[1].length > 2) {
          item.price = item.price.substring(0, item.price.indexOf('.') + 3);
        }
      }
      if ((Number.isNaN(item.price) && item.type != 3 && item.type != 23) || (parseFloat(item.price) > parseFloat(payMoney) && item.type != 3 && item.type != 23)) {
        vm.$message({
          message: `请输入小于${payMoney}的数字!`,
          type: 'error'
        });
        setTimeout(() => {
          item.price = payMoney;
        }, 0);
      } else if (parseFloat(item.price) < 0 || (!Number(parseFloat(item.price)) && item.price != '' && item.price != '0.0')) {
        setTimeout(() => {
          item.price = 0;
        }, 0);
      } else if (item.type == 3) {
        if (item.price * 1 > vm.payMethods.memberMoney * 1) {
          vm.$message({
            message: `请输入小于${vm.payMethods.memberMoney}的数字!`,
            type: 'error'
          });
          setTimeout(() => {
            item.price = vm.payMethods.memberMoney;
          }, 0);
        } else if (parseFloat(item.price) > parseFloat(payMoney)) {
          vm.$message({
            message: `请输入小于${payMoney}的数字!`,
            type: 'error'
          });
          setTimeout(() => {
            item.price = payMoney;
          }, 0);
        }
      } else if (item.type == 23) {
        if ((vm.wholesalePrice * 1 > vm.customerMsg.memberMsg.loanBalance * 1) && (item.price * 1 > vm.customerMsg.memberMsg.loanBalance * 1)) {
          vm.$message({
            message: `请输入小于${vm.customerMsg.memberMsg.loanBalance}的数字!`,
            type: 'error'
          });
          setTimeout(() => {
            item.price = vm.customerMsg.memberMsg.loanBalance;
          }, 0);
        } else if ((vm.customerMsg.memberMsg.loanBalance * 1 > vm.wholesalePrice * 1) && (item.price * 1 > vm.wholesalePrice * 1)) {
          vm.$message({
            message: `请输入小于${vm.wholesalePrice}的数字!`,
            type: 'error'
          });
          setTimeout(() => {
            item.price = vm.wholesalePrice;
          }, 0);
        }
      }

      setTimeout(() => {
        surplusTotal = parseFloat(payMoney) - parseFloat(item.price * 1 > payMoney * 1 ? payMoney * 1 : item.price * 1 <= 0 ? 0 : item.price * 1);// 剩余分配支付金额
      }, 0);
      vm.payTypeList.forEach((val) => {
        if (item != val && val.status) {
          setTimeout(() => {
            val.price = parseFloat(surplusTotal).toFixed(2);
          }, 0);
        }
      });
      if (item.type == 6 || item.type == 21) {
        vm.mohePayMoney = parseFloat(item.price).toFixed(2);
      } else {
        vm.mohePayMoney = parseFloat(surplusTotal).toFixed(2);
      }
    },
    // 确定选择SmartBox设备
    moheChooseConfirm() {
      this.moheDialog = false;
      this.chooseMoheCode = this.defultMoheCode;
    },
    // 选择SmartBox设备
    changeMohe(item) {
      const vm = this;
      vm.mhInfo = item;
      vm.defultMoheCode = item.code;
    },
    // 获取SmartBox设备列表
    getMagicBoxList() {
      const data = {
        orderId: window.sessionStorage.settlementOrderId
      };
      this.loading = true;
      getMagicBoxList(data).then((res) => {
        if (res.code == 0) {
          this.magicBox = res.data ? res.data : [];
          if (!this.chooseMoheCode && this.magicBox.length > 0) {
            this.defultMoheCode = this.magicBox[0].code;
            this.chooseMoheCode = this.magicBox[0].code;
            this.mhInfo = res.data[0];
          }
        } else {
          this.$message(res.msg);
        }
        this.loading = false;
      });
    },
    // 关闭扫码支付窗口
    closeScanDialogDialog() {
      const vm = this;
      vm.scanPayMoney1 = null;
      vm.scanPayMoney2 = null;
      vm.isCloseScan = true;
      vm.scanPayRadio1 = false;
      vm.scanPayRadio2 = false;
      vm.$emit('getPayMethodsMsg', vm.putOutPayMethodsMsg());
      clearInterval(vm.clearGetMoreScanPayStatus);
      clearInterval(vm.clearScanQPayStatus);
    },
    // 改变扫码支付的分配金额
    changeScanPayMoney() {
      const vm = this;
      // eslint-disable-next-line no-restricted-globals
      if (isNaN(vm.scanPayMoney1)) {
        vm.$message({
          message: '请输入正确的数字!',
          type: 'error'
        });
        vm.scanPayMoney1 = parseInt(vm.scanTotal / 2, 10);
      } else if (parseFloat(vm.scanTotal) <= parseFloat(vm.scanPayMoney1)) {
        vm.$message({
          message: `请输入小于${vm.scanTotal}的数字!`,
          type: 'error'
        });
        vm.scanPayMoney1 = parseInt(vm.scanTotal / 2, 10);
      }
      vm.scanPayMoney2 = (vm.scanTotal - (vm.scanPayMoney1 || 0)).toFixed(2);
      clearTimeout(scanPayTimeout);
      scanPayTimeout = setTimeout(() => {
        vm.toPay();
      }, 1000);
    },
    // 获得扫码支付二维码
    getQRCode4ScanPay() {
      const settlementMsg = window.JSON.parse(this.settlementMsg);
      const data = {
        orderId: window.sessionStorage.settlementOrderId,
        money: settlementMsg.resulteMoney,
        payWay: this.changePayImgStatus ? 1 : 2
      };
      getQRCode4ScanPay(data).then((res) => {
        if (res.code == 0) {
          this.morePayOrderCode = res.data.orderCode;
          this.payType4ErweiMa = `${res.data.url}&${new Date().getTime()}`;
          this.dialogVisiblePayType4 = true;
          this.scanQPayLoading = false;
          this.title = '扫码支付';
          this.payStatus = 1;
          this.getScanPayStatus();
        }
      });
    },
    // 营业员扫码
    scanCustomersPay() {
      const vm = this;
      if (vm.scanPayCode == '') {
        vm.$message('请输入付款码');
        return false;
      }
      let payMoney = vm.scanTotal;// 扫码支付金额
      if (vm.scanPayRadio2) { // 扫码支付分两次支付
        if (!vm.scanPayMoney1Result) {
          payMoney = vm.scanPayMoney1;// 扫码支付金额1
        } else {
          payMoney = vm.scanPayMoney2;// 扫码支付金额2
        }
      }
      if (!payMoney) {
        vm.$message('请输入支付金额');
        return false;
      }
      const data = {
        orderCode: vm.morePaySwitch ? vm.morePayOrderCode : vm.sanQPayOrder,
        barCode: vm.scanPayCode,
        orderId: vm.payMethods.orderId,
        money: payMoney,
        payType: vm.scanSelect
      };
      barCodePay(data).then((res) => {
        if (res.code == 0) {
          // console.log(res.msg)
        } else {
          vm.$message(res.msg);
        }
      });
    },
    // 获得扫码,赊账支付状态
    getScanPayStatus() {
      const vm = this;
      this.clearGetScanPayStatus = setInterval(() => {
        getScanPayStatus({ orderCode: this.dialogVisiblePayType4 == true && this.payType == 5 ? this.payMethods.orderCode : this.morePayOrderCode }).then((res) => {
          if (vm.payStatus == 2) return;
          if (res.code == 0) {
            // 0:未支付，1：已支付，-1：已失效
            if (res.data.status == 1) {
              this.tenTimeReturnNum = 10;
              this.tenTimeReturnFlag = false;

              this.$message({
                message: '已支付',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.saveAndIsPrint();
                }
              });
              clearInterval(this.clearGetScanPayStatus);
              clearInterval(this.tenTimeReturnClear);
              vm.payStatus = 2;
            }
            if (res.data.status == -1) {
              clearInterval(this.clearGetScanPayStatus);
              clearInterval(this.tenTimeReturnClear);
              this.$message.error('二维码已失效，请重新获取');
              vm.payStatus = 2;
            }
            if (res.data.status == 2) {
              this.tenTimeReturnNum = 10;
              this.tenTimeReturnFlag = false;
              this.dialogVisiblePayType4 = false;
              clearInterval(this.clearGetScanPayStatus);
              clearInterval(this.tenTimeReturnClear);
              this.$message.error('您的赊账请求被拒绝');
              vm.payStatus = 2;
            }
          } else {
            clearInterval(this.clearGetScanPayStatus);
            clearInterval(this.tenTimeReturnClear);
            this.$message.error(res.msg);
            vm.payStatus = 2;
          }
        });
      }, 1000);
    },
    // 关闭扫描支付弹框
    handleClosePayType4() {
      clearInterval(this.clearGetScanPayStatus);
      clearInterval(this.clearScanQPayStatus);
      clearInterval(this.tenTimeReturnClear);
      Object.assign(this.$data.payTypeList, this.$options.data().payTypeList);
      this.totalPayCode();
      this.dialogVisiblePayType4 = false;
      setTimeout(() => {
        this.payType = 0;
      }, 300);
      this.tenTimeReturnNum = 10;
      this.tenTimeReturnFlag = false;
    },
    // 获得赊账二维码
    getQRCode4Credit() {
      const settlementMsg = window.JSON.parse(this.settlementMsg);
      const data = {
        orderId: this.payMethods.orderId,
        money: settlementMsg.resulteMoney,
        discountMoney: settlementMsg.totalMoney - settlementMsg.resulteMoney,
      };
      getQRCode4Credit(data).then((res) => {
        if (res.code == 0) {
          this.payType4ErweiMa = `${res.data.url}&${new Date().getTime()}`;
          this.creditList = res.data.boxList || [];
          if (res.data.boxList.length == 0) {
            this.creditListValue = '';
          } else {
            this.creditListValue = res.data.boxList[0].phone;
          }
          this.dialogVisiblePayType4 = true;
          this.scanQPayLoading = false;
          this.title = '请选择赊账方式';
          this.payStatus = 1;
          this.getScanPayStatus();
        }
      });
    },
    // 赊账授权非现场授权发送短信
    sendMsg4Serve() {
      this.tenTimeReturnFlag = true;
      sendMsg4Serve({
        orderId: this.payMethods.orderId,
        phone: this.creditListValue
      }).then((res) => {
        if (res.code == 0) {
          this.tenTimeReturn();
        }
      });
    },
    // 10分钟倒计时
    tenTimeReturn() {
      this.tenTimeReturnFlag = true;
      let time = 0;
      this.tenTimeReturnClear = setInterval(() => {
        if (this.tenTimeReturnNum == 0) {
          this.tenTimeReturnNum = 10;
          this.tenTimeReturnFlag = false;
          return clearInterval(this.tenTimeReturnClear);
        }
        time += 1;
        if (time % 60 == 0) {
          this.tenTimeReturnNum -= 1;
        }
      }, 1000);
    },
    // 验证保存信息
    verificationToPay(status) {
      // console.log(status)
      if (this.morePaySwitch == false) {
        const settlementMsg = window.JSON.parse(this.settlementMsg);
        if (this.payType == 1 && settlementMsg.resulteMoney != 0) {
          if (this.returnPayMoney < 0 || this.payamount == '') {
            if (status != 66) {
              this.$message.error('现金支付不正确');
            }
            this.$emit('getPayMethodsMsg', this.putOutPayMethodsMsg());
            return false;
          }
        }
        return true;
      }
      return true;
    },
    // 保存订单data
    toPayData() {
      const vm = this;
      const settlementMsg = window.JSON.parse(vm.settlementMsg);
      if (!settlementMsg.others) {
        settlementMsg.others = {
          couponMsg: {
            cardId: '',
            money: 0,
            num: 0
          },
          fenBiMsg: {
            money: 0,
            num: 0
          },
          jifenMsg: {
            money: 0,
            num: 0
          }
        };
      }
      const newOthers = settlementMsg.others;
      const files = vm.payTypeList;
      const arr = [];
      let newOrderCode;
      for (let a = 0, len = files.length; a < len; a++) {
        const item = files[a];
        const obj = {};
        if (item.status == true) {
          if (vm.morePaySwitch) {
            obj.money = item.price;
            if (item.type == 4 || item.type == 21 || item.type == 6) {
              newOrderCode = vm.morePayOrderCode;
            }
          } else {
            obj.money = settlementMsg.resulteMoney;
            if (item.type == 4 || item.type == 21 || item.type == 6) {
              newOrderCode = vm.sanQPayOrder;
            }
          }
          obj.payType = item.type;
          if (item.type == 3) {
            obj.pwd = vm.payPassword;
          }
          arr.push(obj);
        }
      }
      const partDiscountMoney = ((newOthers.couponMsg ? (newOthers.couponMsg.money * 1) : 0) + (newOthers.fenBiMsg ? (newOthers.fenBiMsg.money * 1) : 0) + (newOthers.jifenMsg ? (newOthers.jifenMsg.money * 1) : 0)).toFixed(2);
      const partPayStatus = (partDiscountMoney == Math.abs((settlementMsg.totalMoney - vm.editMoneyVal * 1 - settlementMsg.resulteMoney).toFixed(2))) ? 0 : 1;
      return {
        orderCode: newOrderCode,
        bankCode: vm.binkOrderNumber, // 银行流水号
        cardId: newOthers.couponMsg.cardId, // 卡券id
        cardNum: newOthers.couponMsg.num, // 使用的卡券数量
        couponMoney: newOthers.couponMsg.money, // 优惠券抵扣金额
        dtoList: this.chooseOutBedList, // 退房/退位信息  6.8
        isOutRoom: this.chooseOutBedList.length > 0 ? 1 : 0, // 结算是否退位(0否 1是)  6.8
        fansCurrency: newOthers.fenBiMsg.num, // 粉币
        fenbiMoney: newOthers.fenBiMsg.money, // 粉币抵扣金额
        integral: newOthers.jifenMsg.num, // 积分
        isPartPay: vm.isPartPay ? 1 : partPayStatus, // 是否是部分支付（0：不是，1：是）
        jifenMoney: newOthers.jifenMsg.money, // 积分抵扣金额
        orderChangeMoney: vm.editMoneyVal, // 改价优惠值
        orderId: vm.payMethods.orderId, // 订单id
        orderSignature: vm.orderSignature,
        partPayType: vm.isPartPay ? 2 : partPayStatus,
        discountMoney: partDiscountMoney, // 抵扣金额
        payTotal: settlementMsg.resulteMoney, // 实际支付金额
        payInfoList: arr, // 支付方式（1：现金支付,2:银行卡支付,3:会员卡,4:扫码支付,5:赊账）
        payamount: !vm.morePaySwitch && vm.payType == 1 ? vm.payamount : '0', // 现金支付客户支付的金额
        returnamount: !vm.morePaySwitch && vm.payType == 1 ? vm.returnPayMoney : '0', // 现金支付找回客户的金额
        // unionDto: starObj,//样子支付需要参数
      };
    },
    // 保存订单并返回首页
    toPay(toPayStatus) {
      const vm = this;
      // var scanMoney = 0;
      vm.roomDia = false;
      const settlementMsg = window.JSON.parse(vm.settlementMsg);
      if (vm.morePaySwitch) {
        // 是否选择了支付方式
        let payTypeCount = 0;
        vm.payTypeList.forEach((val) => {
          if (val.status) {
            payTypeCount++;
          }
        });
        if (payTypeCount == 0) {
          vm.$message('请选择支付方式!');
          vm.$emit('getPayMethodsMsg', vm.putOutPayMethodsMsg());
          return false;
        }
        let payTypeTotal = 0;// 多种支付方式共多少钱
        let payMoneyErr = false;
        vm.payTypeList.forEach((val) => {
          if (val.status) {
            payTypeTotal += parseFloat(val.price);
            if (!val.price || val.price <= 0) {
              payMoneyErr = true;
            }
          }
        });
        if (payMoneyErr) {
          vm.$message('金额分配必须全部大于0');
          vm.$emit('getPayMethodsMsg', vm.putOutPayMethodsMsg());
          return false;
        }
        if (parseFloat(payTypeTotal).toFixed(2) != parseFloat(settlementMsg.resulteMoney).toFixed(2)) {
          vm.$message('支付金额不对!');
          vm.$emit('getPayMethodsMsg', vm.putOutPayMethodsMsg());
          return false;
        }
        vm.scanTotal = 0;
        let moheTotal = 0;
        let balanceStatus = false;
        vm.payTypeList.forEach((val) => {
          if (val.type == 4 && val.status) {
            vm.scanTotal = parseFloat(val.price).toFixed(2);
            // scanMoney = parseFloat(val.price).toFixed(2);
            return;
          }
          if ((val.type == 6 || val.type == 21) && val.status) {
            moheTotal = parseFloat(val.price).toFixed(2);
            return;
          }
          if (val.type == 3) {
            if (val.price * 1 > vm.payMethods.memberMoney * 1) {
              balanceStatus = true;
            }
          }
        });
        if (balanceStatus == true) {
          vm.$message({
            message: `会员余额不足，请输入小于${vm.payMethods.memberMoney}的数字!`,
            type: 'error'
          });
          return;
        }
        if (vm.scanTotal > 0) {
          // if (vm.scanPayRadio1 && !vm.scanPayMoney1Result && vm.scanPayMoney1 > 0) {
          //     scanMoney = vm.scanPayMoney1
          // } else if (vm.scanPayRadio1 && vm.scanPayMoney1Result && vm.scanPayMoney2 > 0) {
          //     scanMoney = vm.scanPayMoney2
          // } else {
          //     scanMoney = vm.scanTotal
          // }
          // eslint-disable-next-line no-shadow
          const settlementMsg = window.JSON.parse(vm.settlementMsg);
          const data = {
            orderId: window.sessionStorage.settlementOrderId,
            money: settlementMsg.resulteMoney,
            payWay: vm.changePayImgStatus ? 1 : 2
          };
          getQRCode4ScanPay(data).then((res) => {
            if (res.code == 0) {
              vm.scanCodeUrl = `${res.data.url}&${new Date().getTime()}`;
              vm.morePayOrderCode = res.data.orderCode;
              vm.scanDialog = true;
              vm.scanQPayLoading = false;
              vm.title = '扫码支付';
              vm.payStatus = 1;
            }
          });

          // vm.paymentCode = ''
          // vm.changePayImgStatus = true
          // getOrderCode({ orderCode: vm.payMethods.orderCode }).then(res => {
          //     vm.morePayOrderCode = res.data.orderCode
          //     vm.scanDialog = true;
          //     vm.title = '扫码支付'
          //     vm.sanQPayStatus(res.data.orderCode)
          // })
          return;
        }
        if (moheTotal > 0) {
          if (!vm.chooseMoheCode) {
            vm.$message('请选择SmartBox设备');
            return false;
          }
          if (vm.smartBoxStatus == 6) {
            getOrderCode({ orderCode: vm.payMethods.orderCode }).then((resTwo) => {
              vm.morePayOrderCode = resTwo.data.orderCode;
              toPayBefore(vm.toPayData()).then(() => {});
              const dataOne = {
                orderId: window.sessionStorage.settlementOrderId,
                eqCode: vm.chooseMoheCode,
                eqId: vm.mhInfo.eq_id,
                orderCode: vm.morePayOrderCode,
                total: moheTotal
              };
              receptionOrder(dataOne).then((res) => {
                if (res.code == 0) {
                  vm.mohePayStatus = true;
                  vm.payStatus = 1;
                  vm.getMoreScanPayStatus();
                  setTimeout(() => {
                    vm.$message({
                      message: '订单已推送到SmartBox，请在SmartBox完成支付！',
                      type: 'success',
                      duration: 1500,
                    });
                  }, 300);
                }
              });
            });
          } else if (vm.smartBoxStatus == 21) {
            const { href } = window.location;
            let http = '';
            if (href.includes('duofriend')) {
              http = 'm.duofriend.com';
            } else if (href.includes('https://nb')) {
              http = 'nbm.deeptel.com.cn';
            } else {
              http = 'm.deeptel.com.cn';
            }
            getOrderCode({ orderCode: vm.payMethods.orderCode }).then((resTwo) => {
              this.morePayOrderCode = resTwo.data.orderCode;
              toPayBefore(vm.toPayData()).then(() => {});
              const url = `https://${sessionStorage.getItem('busId')}.${http}/beauty/static/fans/index.html#/pages/distributorPay/distributorPay?storeId=${window.sessionStorage.mainId}&busId=${sessionStorage.getItem('busId')}&price=${moheTotal}&orderType=3&orderCode=${vm.morePayOrderCode}&orderId=${vm.payMethods.orderId}`;
              const dataOne = {
                bizData: url,
                eqCode: vm.chooseMoheCode,
                eqId: vm.mhInfo.eq_id,
                mainId: window.sessionStorage.mainId,
                orderNo: vm.morePayOrderCode,
                paymentAmount: moheTotal
              };
              payQrOrderPush(dataOne).then((res) => {
                if (res.code == 0) {
                  vm.mohePayStatus = true;
                  vm.payStatus = 1;
                  vm.getMoreScanPayStatus();
                  setTimeout(() => {
                    vm.$message({
                      message: '订单已推送到SmartBox，请在SmartBox完成支付！',
                      type: 'success',
                      duration: 1500,
                    });
                  }, 300);
                }
              });
            });
          }
          return;
        }
        if (!vm.verificationToPay(toPayStatus)) return;
        if (toPayStatus == 'room' && this.dtoList.length > 1 && this.chooseOutBedList.length == 0) {
          vm.roomDia = true;
          setTimeout(() => {
            this.dtoList.forEach((a) => {
              this.$refs.outRoomTable.toggleRowSelection(a);
            });
          }, 0);
          return;
        }
        if (toPayStatus == 'room' && this.dtoList.length == 1 && this.chooseOutBedList.length == 0) {
          const arr = [];
          this.dtoList.forEach((a) => {
            const obj = {};
            obj.roomOrderId = a.roomOrderId;
            obj.mainId = window.sessionStorage.mainId;
            arr.push(obj);
          });
          this.chooseOutBedList = arr;
        }
        if (window.sessionStorage.isAutograph == 1 && vm.customerMsg.phone) {
          vm.$refs.child.show = true;
          return;
        }
        const loading = this.$loading({
          lock: true,
          text: '支付中，请稍等',
          spinner: 'el-icon-loading',
          customClass: 'loadNoneedImg',
          background: 'rgba(0, 0, 0, 0.5) !important'
        });
        const dataTwo = vm.toPayData();
        toPay(dataTwo).then((res) => {
          if (res.code == 0) {
            vm.$message({
              message: '订单结算成功！',
              type: 'success',
              duration: 2000,
              onClose: () => {
                vm.returnHome();
              }
            });
          } else {
            vm.$message.error(res.msg);
            vm.$emit('getPayMethodsMsg', vm.putOutPayMethodsMsg());
            vm.dialogVisiblePayType4 = false;
          }
          loading.close();
        });
      }
      let payTypeCount = 0;
      vm.payTypeList.forEach((val) => {
        if (val.status) {
          payTypeCount++;
        }
      });
      if (payTypeCount == 0) {
        vm.$message('请选择支付方式!');
        return;
      }
      if (vm.payType == 5) {
        const slMsg = window.JSON.parse(this.settlementMsg);
        const totalOne = slMsg.others ? slMsg.others.couponMsg ? (slMsg.others.couponMsg.money * 1) : 0 : 0;
        const totalTwo = slMsg.others ? slMsg.others.fenBiMsg ? (slMsg.others.fenBiMsg.money * 1) : 0 : 0;
        const totalThree = slMsg.others ? slMsg.others.jifenMsg ? (slMsg.others.jifenMsg.money * 1) : 0 : 0;
        const totalMsg = (totalOne + totalTwo + totalThree + vm.editMoneyVal * 1 + (slMsg.others ? (slMsg.others.resulteMoney ? (slMsg.others.resulteMoney * 1) : (slMsg.resulteMoney * 1)) : (slMsg.resulteMoney * 1))).toFixed(2);
        if ((totalMsg != slMsg.totalMoney) || vm.isPartPay == 1) {
          vm.$message({
            message: '已使用部分支付，不能进行赊账',
            type: 'error'
          });
          vm.$emit('getPayMethodsMsg', vm.putOutPayMethodsMsg());
          return;
        }
      }
      if (vm.payType == 6 || vm.payType == 21) {
        if (vm.payType == 6) {
          getOrderCode({ orderCode: vm.payMethods.orderCode }).then((resTwo) => {
            vm.sanQPayOrder = resTwo.data.orderCode;
            toPayBefore(vm.toPayData()).then(() => {});
            const dataThree = {
              orderId: window.sessionStorage.settlementOrderId,
              eqCode: vm.chooseMoheCode,
              eqId: vm.mhInfo.eq_id,
              orderCode: vm.sanQPayOrder,
              total: settlementMsg.resulteMoney
            };
            receptionOrder(dataThree).then((res) => {
              if (res.code == 0) {
                vm.mohePayStatus = true;
                vm.payStatus = 1;
                vm.sanQPayStatus();
                setTimeout(() => {
                  vm.$message({
                    message: '订单已推送到SmartBox，请在SmartBox完成支付！',
                    type: 'success',
                    duration: 1500,
                  });
                }, 300);
              }
            });
          });
        } else {
          const { href } = window.location;
          let http = '';
          if (href.includes('duofriend')) {
            http = 'm.duofriend.com';
          } else if (href.includes('https://nb')) {
            http = 'nbm.deeptel.com.cn';
          } else {
            http = 'm.deeptel.com.cn';
          }
          getOrderCode({ orderCode: vm.payMethods.orderCode }).then((resTwo) => {
            this.sanQPayOrder = resTwo.data.orderCode;
            toPayBefore(vm.toPayData()).then(() => {});
            const url = `https://${sessionStorage.getItem('busId')}.${http}/beauty/static/fans/index.html#/pages/distributorPay/distributorPay?storeId=${window.sessionStorage.mainId}&busId=${sessionStorage.getItem('busId')}&price=${settlementMsg.resulteMoney}&orderType=3&orderCode=${vm.sanQPayOrder}&orderId=${vm.payMethods.orderId}`;
            const dataOne = {
              bizData: url,
              eqCode: vm.chooseMoheCode,
              eqId: vm.mhInfo.eq_id,
              mainId: window.sessionStorage.mainId,
              orderNo: vm.sanQPayOrder,
              paymentAmount: settlementMsg.resulteMoney
            };
            payQrOrderPush(dataOne).then((res) => {
              if (res.code == 0) {
                vm.mohePayStatus = true;
                vm.payStatus = 1;
                vm.sanQPayStatus();
                setTimeout(() => {
                  vm.$message({
                    message: '订单已推送到SmartBox，请在SmartBox完成支付！',
                    type: 'success',
                    duration: 1500,
                  });
                }, 300);
              }
            });
          });
        }
        return;
      }
      if (!vm.verificationToPay(toPayStatus)) return;
      if (toPayStatus == 'room' && this.dtoList.length > 1 && this.chooseOutBedList.length == 0) {
        vm.roomDia = true;
        setTimeout(() => {
          this.dtoList.forEach((a) => {
            this.$refs.outRoomTable.toggleRowSelection(a);
          });
        }, 0);
        return;
      }
      if (toPayStatus == 'room' && this.dtoList.length == 1 && this.chooseOutBedList.length == 0) {
        const arr = [];
        this.dtoList.forEach((a) => {
          const obj = {};
          obj.roomOrderId = a.roomOrderId;
          obj.mainId = window.sessionStorage.mainId;
          arr.push(obj);
        });
        this.chooseOutBedList = arr;
      }
      if (window.sessionStorage.isAutograph == 1 && vm.customerMsg.phone) {
        vm.$refs.child.show = true;
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '支付中，请稍等',
        spinner: 'el-icon-loading',
        customClass: 'loadNoneedImg',
        background: 'rgba(0, 0, 0, 0.5) !important'
      });
      const dataFour = vm.toPayData();
      toPay(dataFour).then((res) => {
        if (res.code == 0) {
          vm.$message({
            message: '订单结算成功！',
            type: 'success',
            duration: 2000,
            onClose: () => {
              vm.returnHome();
            }
          });
        } else {
          vm.$message.error(res.msg);
          vm.$emit('getPayMethodsMsg', vm.putOutPayMethodsMsg());
          vm.dialogVisiblePayType4 = false;
        }
        loading.close();
      });
    },
    // 关闭SmartBox支付
    closeMohePay() {
      const vm = this;
      if (vm.smartBoxStatus == 6) {
        vm.mohePayStatus = false;
        vm.$emit('getPayMethodsMsg', vm.putOutPayMethodsMsg());
        clearInterval(vm.clearGetMoreScanPayStatus);
        clearInterval(vm.clearScanQPayStatus);
      } else {
        cancelSmartBoxPush({
          orderCode: vm.morePaySwitch ? vm.morePayOrderCode : vm.sanQPayOrder,
        }).then((res) => {
          if (res.code == 0) {
            vm.$message('已取消推送');
          }
          vm.mohePayStatus = false;
          vm.$emit('getPayMethodsMsg', vm.putOutPayMethodsMsg());
          clearInterval(vm.clearGetMoreScanPayStatus);
          clearInterval(vm.clearScanQPayStatus);
        });
      }
    },
    // 多种支付--扫码支付监听事件
    getMoreScanPayStatus() {
      const vm = this;
      clearInterval(vm.clearGetMoreScanPayStatus);
      vm.clearGetMoreScanPayStatus = setInterval(() => {
        getScanPayStatus({
          orderCode: vm.morePaySwitch ? vm.morePayOrderCode : vm.sanQPayOrder,
          payWay: vm.changePayRadioVal
        }).then((res) => {
          if (vm.payStatus == 2) return;
          if (res.code == 0) {
            // 0:未支付，1：已支付，-1：已失效
            if (res.data.status == 1) {
              if (vm.scanPayRadio1 && !vm.scanPayMoney1Result && vm.scanPayMoney1 > 0) {
                vm.changePayRadio = true;
                vm.scanPayMoney1Result = true;
                vm.toPay();
              } else if (vm.scanPayRadio1 && vm.scanPayMoney1Result && vm.scanPayMoney1 > 0) {
                vm.scanPayMoney2Result = true;
                vm.$message({
                  message: '已支付',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    vm.saveAndIsPrint();
                  }
                });
                clearInterval(vm.clearGetMoreScanPayStatus);
                vm.payStatus = 2;
              } else if (vm.scanPayRadio2 && !vm.scanPayMoney1Result && vm.scanPayMoney1 > 0) {
                vm.scanPayMoney1Result = true;
                vm.scanPayCode = '';
                vm.toPay();
              } else if (vm.scanPayRadio2 && vm.scanPayMoney1Result && vm.scanPayMoney1 > 0) {
                vm.scanPayMoney2Result = true;
                vm.$message({
                  message: '已支付',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    vm.saveAndIsPrint();
                  }
                });
                clearInterval(vm.clearGetMoreScanPayStatus);
                vm.payStatus = 2;
              } else if (!vm.scanPayRadio1 && !vm.mohePayStatus) {
                vm.$message({
                  message: '已支付',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    vm.saveAndIsPrint();
                  }
                });
                clearInterval(vm.clearGetMoreScanPayStatus);
                vm.payStatus = 2;
              } else if (!vm.scanPayRadio2 && !vm.mohePayStatus) {
                vm.$message({
                  message: '已支付',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    vm.saveAndIsPrint();
                  }
                });
                clearInterval(vm.clearGetMoreScanPayStatus);
                vm.payStatus = 2;
              } else if (vm.mohePayStatus) {
                vm.mohePayStatus = false;
                vm.$message({
                  message: '已支付',
                  type: 'success',
                  duration: 100,
                  onClose: () => {
                    vm.saveAndIsPrint();
                  }
                });
                clearInterval(vm.clearGetMoreScanPayStatus);
                vm.payStatus = 2;
              }
            } else if (res.data.status == -1) {
              clearInterval(vm.clearGetMoreScanPayStatus);
              vm.$message.error('二维码已失效，请重新获取');
              vm.payStatus = 2;
            }
          } else {
            clearInterval(vm.clearGetMoreScanPayStatus);
            vm.$message.error(res.msg);
            vm.payStatus = 2;
          }
        });
      }, 1000);
    },
    // 监听支付状态并保存
    saveAndIsPrint() {
      const vm = this;
      if (!vm.verificationToPay()) return;
      if (window.sessionStorage.isAutograph == 1 && vm.customerMsg.phone) {
        vm.$refs.child.show = true;
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '支付中，请稍等',
        spinner: 'el-icon-loading',
        customClass: 'loadNoneedImg',
        background: 'rgba(0, 0, 0, 0.5) !important'
      });
      const data = vm.toPayData();
      toPay(data).then((res) => {
        if (res.code == 0) {
          vm.$message({
            message: '订单结算成功！',
            type: 'success',
            duration: 2000,
            onClose: () => {
              vm.returnHome();
            }
          });
        } else {
          vm.$message.error(res.msg);
          vm.$emit('getPayMethodsMsg', vm.putOutPayMethodsMsg());
          vm.dialogVisiblePayType4 = false;
        }
        loading.close();
      });
    },
    // 关闭返回首页
    returnHome() {
      const vm = this;
      const settlementMsg = window.JSON.parse(vm.settlementMsg);
      vm.dialogVisiblePayType4 = false;
      vm.$store.commit('deleteTabs', 'stage-orderSettlement');
      window.sessionStorage.printOrderStatus = 1;
      vm.$router.replace({
        name: 'stage-settlementSuccess'
      });
      vm.chooseOutBedList = [];
      vm.payPassword = '';
      vm.payType = 0;
      window.sessionStorage.editOrderId = '';
      window.sessionStorage.successOrderId = vm.payMethods.orderId;
      window.sessionStorage.successResulteMoney = settlementMsg.resulteMoney;
      // isPartPay 1 是部分支付
      window.sessionStorage.successOrderType = 1;
      // Object.assign(this.$data, this.$options.data())
    }
  }
};
// eslint-disable-next-line no-unused-vars
function didGetQRCode(code) {

}
</script>

<!-- 付款方式-->
<style lang="less" scoped>
.stage-pay-method {
  clear: both;
  .el-switch {
    top: -2px;
    margin-right: 5px;
  }
  h5 {
    position: absolute;
    margin: -41px 0 0 100px;
    color: #999;
    font-size: 14px;
    font-weight: 500;
    height: 24px;
    line-height: 24px;
    padding: 0 0 20px 0;
    span {
      color: #333333;
    }
  }
  .list {
    list-style-type: none;
    overflow: visible;
    li:hover {
      transition: all 0s;
      transform: scale(1);
      -webkit-transform: scale(1);
      -moz-transform: scale(1);
      -o-transform: scale(1);
      -ms-transform: scale(1);
      font-weight: 600;
    }
    li {
      width: 145px;
      height: 90px;
      border: 1px solid #409eff;
      border-radius: 5px;
      margin: 0 20px 20px 0;
      font-size: 16px;
      text-align: center;
      color: #409eff;
      cursor: pointer;
      float: left;
      &.active {
        background-color: #409eff;
        color: #ffffff;
      }
      .text {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0 10px;
        width: 125px;
      }
    }
    .icon {
      padding: 13px 0 10px;
      min-height: 36px;
    }
    .iconfont {
      font-size: 36px;
    }
  }
  ul:after {
    content: "";
    display: table;
    clear: both;
  }
  .pay-cash {
    min-height: 40px;
    line-height: 40px;
    padding: 10px 20px;
    background: #ffffff;
    box-shadow: 0px 0px 6px rgba(153, 153, 153, 0.1);
    border-radius: 4px;
    font-size: 14px;
    color: #333333;
    clear: both;
    .input {
      width: 240px;
      float: left;
      margin-right: 20px;
      margin-bottom: 15px;
    }
    .number {
      font-size: 20px;
      color: #ff4949;
    }
  }
}
.gz-box {
  width: 515px;
  font-size: 14px;
  color: #333333;
  .gz-left {
    width: 190px;
    float: left;
    overflow: hidden;
    padding-right: 50px;
    border-right: 1px solid #eeeeee;
  }
  .gz-right {
    width: 220px;
    float: left;
    overflow: hidden;
    padding-left: 50px;
  }
  .padding30 {
    padding-bottom: 30px;
  }
}
.mohe-dialog-number ul {
  list-style-type: none;
  li {
    margin-right: 10px;
    margin-bottom: 12px;
    cursor: pointer;
    text-align: center;
    border: 1px solid #bcbcbc;
    border-radius: 5px;
    width: 203px;
    padding: 20px 0;
    float: left;
    .mohe-dialog-text {
      width: 183px;
      margin: 0 auto;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  :nth-child(4n) {
    margin-right: 0;
  }
  .active {
    border: 1px solid #20a0ff;
    position: relative;
  }
}
.mohe-dialog-number .active:after {
  position: absolute;
  bottom: 0;
  right: 0;
  content: "";
  width: 25px;
  height: 25px;
  background: url(/static/erp/static/images/choose_icon.png) no-repeat;
}
.clearFix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
}
.mohe {
  margin: 0;
  .mohe-number {
    margin-top: 15px;
    ul {
      list-style-type: none;
      li {
        cursor: pointer;
        text-align: center;
        border: 1px solid #999;
        border-radius: 5px;
        width: 158px;
        padding: 30px 0;
        margin-bottom: 15px;
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        color: #333;
        .mohe-dialog-text {
          width: 100px;
          margin: 0 auto;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
}
.mohe .mohe-number ul .active {
  border: 1px solid #20a0ff;
  position: relative;
}
.mohe .mohe-number ul .active:after {
  position: absolute;
  bottom: 0;
  right: 0;
  content: "";
  width: 35px;
  height: 35px;
  background: url(/static/erp/static/images/choose_icon2.png) no-repeat;
}

.clearFix {
  width: 100%;
  .scan-left {
    width: 320px;
    float: left;
    border-right: 1px solid #eee;
    .pay1 {
      margin-top: 15px;
      position: relative;
      z-index: 1;
    }
    .pay-scan {
      margin-top: 5px;
      img {
        height: 290px;
        position: relative;
        top: -17px;
        left: -29px;
        z-index: 0;
      }
      .pay-scan-msg {
        margin: 119px auto 200px auto;
        font-size: 15px;
        font-weight: 700;
        color: red;
        text-align: center;
      }
    }
    .pay-1 {
      text-align: left;
      margin-top: -32px;
      position: relative;
      z-index: 1;
    }
  }
  .scan-right {
    width: 294px;
    float: right;
    .pay2 {
      margin-top: 15px;
    }
    .right-input {
      margin-top: 15px;
    }
    .input-money {
      margin-top: 15px;
      width: 100%;
    }
    .pay-2 {
      padding-left: 5px;
      text-align: left;
      margin-top: 15px;
    }
  }
}
.scanInput {
  width: 240px !important;
  margin-top: 20px !important;
}
.scanSpan {
  color: #67c23a !important;
}
.hdScanIcon {
  width: 16px;
  height: 16px;
  position: absolute;
  z-index: 1;
  margin: 20px 0 0 92px;
  padding: 12px 10px;
  cursor: pointer;
}
</style>

<style>
.input-with-select .el-input__inner {
  padding-left: 36px !important;
}
</style>
